// extracted by mini-css-extract-plugin
export default {"inpLabel":"caseStudy_inpLabel__+ZyH1","inpfield":"caseStudy_inpfield__we0x1"};